import { render, staticRenderFns } from "./resumetwo_template.vue?vue&type=template&id=6b508aac&"
import script from "./resumetwo_template.vue?vue&type=script&lang=js&"
export * from "./resumetwo_template.vue?vue&type=script&lang=js&"
import style0 from "./resumetwo_template.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports